<template>
    <div class="row">
        <div class="col">
            <div class="row">
                <div class="col intro">
                    <h2>Ready for electric cars and vans? Use our tool to find out</h2>
                    <p>Anticipating the right time to make the move to plug-in hybrid and electric cars and vans can be a
                        challenge, and we know that there are many areas to consider – from charging and electric
                        vehicle choice to Plug-in Vehicle Grants. With our free self-assessment EV Ready? tool, we’ve
                        applied our expertise to help you measure how ready your business is.</p>

                    <p>At the end of a series of questions, we’ll assess your maturity across all the key areas and
                        identify areas of strength and weakness, so you can clearly see whether or not your business is
                        ready to make the transition. We’ll also direct you to the resources and support available to
                        you based on your results.</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="box box--grey">
                        <h2>Before we start</h2>
                        <p>Before we can paint a picture in terms of EV readiness, we’d like you to assess where you
                            think your business sits now. So, whether you’ve just started exploring the opportunities
                            that electric vehicles can bring or are well on your way to introducing electric cars and
                            vans into your fleet, drag the slider below to let us know. </p>
                    </div>
                </div>
            </div>
            <div class="row slider-row d-none d-lg-block">
                <div class="col slider">
                    <RangeSelect></RangeSelect>
                </div>
            </div>
            <div class="row d-lg-none">
                <div class="col">
                    <RangeSelectVertical></RangeSelectVertical>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <NavButtons :back="goBack"></NavButtons>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import RangeSelect from './partials/RangeSelect'
    import RangeSelectVertical from './partials/RangeSelectVertical'
    import NavButtons from './partials/NavButtons'

    export default {
        name: "Intro",
        components: {
            RangeSelect,
            RangeSelectVertical,
            NavButtons
        },
        data() {
            return {
                goBack: false,
            }
        }
    }
</script>

<style lang="stylus">
    .slider-row
        .slider
            margin: 2rem 0 0
            padding: 0


    .box
        &--grey
            padding 3rem 3rem
            background-color $color-grey
            text-align center
            margin-top 1rem
            margin-bottom 1rem
            h2
                margin-top 0
            &:not(:last-child)
                margin-bottom 1.5rem

</style>